import { useTranslation } from "react-i18next";
import { IFormBuilderCheckbox, TFormBuilderCheckboxSettings } from "../../../model/item/formBuilderCheckbox";
import { useFormBuilderEditorContext } from "../../../formBuilderEditorContext";
import { useFormBuilderDebouncedUpdate } from "../../../hooks/debouncedUpdate/useFormBuilderDebouncedUpdate";
import { cloneDeep } from "lodash";
import Input from "components/form/input/Input";
import React from "react";

interface IFormBuilderCheckboxSettingsProps {
  item: IFormBuilderCheckbox;
}

export function FormBuilderCheckboxSettings(props: IFormBuilderCheckboxSettingsProps) {
  const { item } = props;

  const { t } = useTranslation();

  const { formBuilderController } = useFormBuilderEditorContext();

  const settings = item.data.settings;

  const debouncedLabel = useFormBuilderDebouncedUpdate<string>({
    defaultValue: "",
    value: settings.label,
  });

  function dispatchSettings(partialNextSettings: Partial<TFormBuilderCheckboxSettings>) {
    formBuilderController.updateItemSettings({
      key: item.key,
      prevItemSettings: {
        type: item.data.type,
        settings: cloneDeep(settings),
      },
      nextItemSettings: {
        type: item.data.type,
        settings: {
          ...cloneDeep(settings),
          ...partialNextSettings,
        },
      },
    });
  }

  return (
    <Input
      label={t("Label")}
      value={debouncedLabel.state.active ? debouncedLabel.state.value : settings.label}
      onFocus={debouncedLabel.activate}
      onChange={e => {
        debouncedLabel.change(e.target.value, label => {
          dispatchSettings({ label });
        });
      }}
      onBlur={() =>
        debouncedLabel.commit(label => {
          dispatchSettings({ label });
        })
      }
    />
  );
}